/**
 * Grand Quack Auto — duck entity factory.
 *
 * Assembles the full duck from geometry helpers in duckGeometry.ts.
 * The group hierarchy uses named children so the animation system
 * can access body parts via getObjectByName().
 *
 * See research.md §2 "Duck character" and marketing materials for target look.
 */

import * as THREE from 'three';
import type { World } from '../types';
import { buildBody, buildFeet, buildHead, buildTail, buildWings } from './duckGeometry';

/**
 * Build the duck group and add it to world.scene.
 * Mutates world.duck to point at the new group.
 */
export const createDuck = (world: World): THREE.Group => {
  const group = new THREE.Group();
  group.name = 'duck';

  // Assemble body parts — all named for animation system access.
  group.add(buildBody());
  group.add(buildHead());

  const [leftWing, rightWing] = buildWings();
  group.add(leftWing, rightWing);

  group.add(buildTail());

  const [leftFoot, rightFoot] = buildFeet();
  group.add(leftFoot, rightFoot);

  group.position.set(0, 0, 0);
  world.scene.add(group);
  world.duck = group;
  return group;
};
